import React from 'react'
import Translations from '@helpers/translations'
import Stars from '@components/ui/Stars'
import styles from './reviewItemStyles.module.scss'

export type ReviewItemProps = {
  title?: string
  description: string
  author: string
  stars: number
  location?: string
  date?: string
}

function ReviewItem({
  title,
  description,
  stars,
  author,
  location,
  date
}: ReviewItemProps) {
  return (
    <article className={styles.ReviewItem}>
      <div className={styles.ReviewItem__rating}>
        <Stars value={stars} color="color2" />
      </div>
      <div className={styles.ReviewItem__copy}>
        {title && <h3 className={styles.ReviewItem__title}>{title}</h3>}
        <p className={styles.ReviewItem__description}>{description}</p>
      </div>

      <footer className={styles.ReviewItem__author}>
        <p>
          <span>{author}</span>
          {location
            ? ` ${Translations.localise('common.reviews.from')} ${location}`
            : ''}
        </p>
        {date && <time>{date}</time>}
      </footer>
    </article>
  )
}

export default ReviewItem

export function ReadMorePanel({ onClick }: { onClick: () => void }) {
  return (
    <button onClick={onClick} className={styles.ReviewItemReadMore}>
      <span className={styles.ReviewItemReadMore__cta}>
        <span className={styles.ReviewItemReadMore__label}>Read more</span>
        <span className={styles.ReviewItemReadMore__underline} />
      </span>
    </button>
  )
}
